import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  Icon?: any
  label?: string
  hint?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, Icon, label, hint, ...props }, ref) => {
    return (
      <div className={cn("flex flex-col gap-1", className)}>
        {label && <label className="text-neutral-600">{label}</label>}
        <div className="flex h-[48px] w-full items-center gap-4 rounded-md bg-neutral-200 px-4">
          {Icon && <Icon color="#a3a3a3" className="h-6 w-6 fill-[#a3a3a3]" />}
          <input
            type={type}
            className={cn(
              "flex h-full disabled:opacity-40 w-full appearance-none bg-transparent text-main-black placeholder:text-neutral-400 focus:outline-none focus:ring-0"
            )}
            ref={ref}
            {...props}
          />
        </div>
        <p
          className={cn("h-3 text-neutral-600", {
            "opacity-0": !hint,
          })}
        >
          {hint}
        </p>
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
